import { LineChart } from "@mui/x-charts/LineChart";
import { COLORS } from "../_cons/StyleConstants";
import TimeUtils from "../../nonview/base/TimeUtils";
import InformationGroup from "./InformationGroup";
import { useTranslation } from "react-i18next";
import HydrometricStation from "../../nonview/core/ents/places/HydrometricStation";

const DASHED_STYLE = {
  strokeDasharray: "5 5",
};

export default function WaterLevelChart({ waterLevelHistory }) {
  const { t } = useTranslation();
  const chartData = [...waterLevelHistory].reverse().slice(-168); // Last 7d
  const xAxisData = chartData.map((d) => new Date(d.timeUt * 1000));
  const yAxisData = chartData.map((d) => d.waterLevelM);

  const series = [
    {
      data: yAxisData,
      label: t("Water Level"),
      color: COLORS.water,
      showMark: false,
    },
  ];

  const floodLevels = [
    {
      level: HydrometricStation.alertLevelM,
      label: "Alert Level",
      color: COLORS.lowAlert,
    },
    {
      level: HydrometricStation.minorFloodLevelM,
      label: "Minor Flood Level",
      color: COLORS.mediumAlert,
    },
    {
      level: HydrometricStation.majorFloodLevelM,
      label: "Major Flood Level",
      color: COLORS.highAlert,
    },
  ];

  floodLevels.forEach(({ level, label, color }) => {
    if (level) {
      series.push({
        data: Array(xAxisData.length).fill(level),
        label: t(label),
        color,
        showMark: false,
        style: DASHED_STYLE,
      });
    }
  });

  return (
    <InformationGroup
      title="Water Level History"
      dataSourceList={[HydrometricStation.getWaterLevelAlertDataSource()]}
    >
      <LineChart
        xAxis={[
          {
            data: xAxisData,
            scaleType: "time",
            tickLabelStyle: {
              fontSize: 10,
            },

            valueFormatter: (date, context) => {
              if (context.location === "tick") {
                return TimeUtils.formatMMMDD(date);
              } else {
                return TimeUtils.formatMMMDDIImmp(date);
              }
            },
          },
        ]}
        yAxis={[
          {
            label: t("Water Level (m)"),
            valueFormatter: (value) => `${value.toFixed(0)}m`,
          },
        ]}
        series={series}
        margin={5}
        grid={{ vertical: true, horizontal: true }}
        sx={{
          "& .MuiLineElement-series-auto-generated-id-1": {
            strokeDasharray: "5 5",
          },
          "& .MuiLineElement-series-auto-generated-id-2": {
            strokeDasharray: "5 5",
          },
          "& .MuiLineElement-series-auto-generated-id-3": {
            strokeDasharray: "5 5",
          },
          width: { xs: "80vw", md: "calc(80vw - 80vh)" },
          height: { xs: "calc(80vw * 9/16)", md: "calc((80vw - 80vh) * 9/16)" },
        }}
      />
    </InformationGroup>
  );
}
